import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      Common: 'Commom',
      SpaceManagement: 'SpaceManagement',
      docFontSize:'fontSize',
      leftMenuShow:'leftMenuShow',
    })
  },
  methods: {
    ...mapMutations({
      SETTITLE: 'SpaceManagement/SETTITLE',
      SETLOGNUMBER: 'SpaceManagement/SETLOGNUMBER',
      SETNUMBER: 'SpaceManagement/SETNUMBER',
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      setLeftMenuIndex_M:"SET_LEFTMENU_INDEX",
    }),
    ...mapActions({
      findSpaceList: 'SpaceManagement/findSpaceList',
      findAllListCreate: 'SpaceManagement/findAllListCreate',
      findAllList: 'SpaceManagement/findAllList',
      addSpace: 'SpaceManagement/addSpace',
      addOrEdit: 'SpaceManagement/addOrEdit',
      findLog: 'SpaceManagement/findLog',
      findById: 'SpaceManagement/findById',
      editVisitorFrozenById: 'SpaceManagement/editVisitorFrozenById',
      editSpaceFrozenById: 'SpaceManagement/editSpaceFrozenById',
      findAppInfoAll: 'SpaceManagement/findAppInfoAll',
      editDeadNameById: 'SpaceManagement/editDeadNameById',
      getWxPayOrder: 'SpaceManagement/getWxPayOrder',
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/PartII/SpaceManagement/components/Mixins.js